
export enum AsyncComponentSuperAdminEnum {
  SuperAdminTabs = 'SuperAdminTabs',
  CodeTablesNameMutateForm = 'CodeTablesNameMutateForm',
  CodeTablesNameListForm = 'CodeTablesNameListForm',
  CodeTablesMutateForm = 'CodeTablesMutateForm',
  CodeTablesListForm = 'CodeTablesListForm',
  CodeTablesParameter = 'CodeTablesParameter'

}

export const superAdminComponents = {
  [ AsyncComponentSuperAdminEnum.SuperAdminTabs ]: () => import( '@/components/superAdmin/SuperAdminTabs.vue' ),
  [ AsyncComponentSuperAdminEnum.CodeTablesNameMutateForm ]: () => import( '@/components/superAdmin/CodeTablesNameMutateForm.vue' ),
  [ AsyncComponentSuperAdminEnum.CodeTablesNameListForm ]: () => import( '@/components/superAdmin/CodeTablesNameListForm.vue' ),
  [ AsyncComponentSuperAdminEnum.CodeTablesMutateForm ]: () => import( '@/components/superAdmin/CodeTablesMutateForm.vue' ),
  [ AsyncComponentSuperAdminEnum.CodeTablesListForm ]: () => import( '@/components/superAdmin/CodeTablesListForm.vue' ),
  [ AsyncComponentSuperAdminEnum.CodeTablesParameter ]: () => import( '@/components/superAdmin/parameter/CodeTablesParameter.vue' )
}
